import {
  Box,
  Typography,
  useTheme,
  Grid,
  Chip,
  Avatar,
  Skeleton,
} from "@mui/material";
import { API_endpoints } from "../../../../API/API_Endpoints";
import { useCompanyId } from "../../../../Context/CompanyIdContext";
import ButtonComponent from "../../../../Component/Button/Button";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { NavRoutes } from "../../../../Component/Navbar/NavRoutes";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
// import disIcon from "../../../../Assets/images/distance.webp";
import premiumTruckLogo from "../../../../Assets/images/p2.webp";
// import RoomIcon from "@mui/icons-material/Room";
// import StarIcon from "@mui/icons-material/Star";

const CatServiceCard = ({ data, index, openModal }) => {
  const theme = useTheme();
  const { companyId } = useCompanyId();
  const isOwner = data?.company_id == companyId ?? false;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    const imageUrl =
      index === 0
        ? data?.food_truck_image?.[0]?.image
        : data?.image?.[0]?.image;
    if (imageUrl) {
      const fullUrl = API_endpoints.baseURL + imageUrl;
      const img = new Image();
      img.src = fullUrl;
      img.onload = () => {
        setImageSrc(fullUrl);
        setImageLoaded(true);
      };
      img.onerror = () => setImageLoaded(true); // avoid stuck loading if image fails
    } else {
      setImageLoaded(true);
    }
  }, [data, index]);

  const truncateCompanyName = (name, length) => {
    if (!name) return "";
    return name?.length > length ? name?.slice(0, length) + "..." : name;
  };

  const redirect = () => {
    toast.warn(t("Login.loginReq"));
    localStorage.setItem("redirectPath", location.pathname);
    navigate(NavRoutes.LOGIN);
  };

  return (
    <Grid
      container
      direction="column"
      xs={12}
      sm={9}
      md={12}
      lg={12}
      sx={{
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        borderRadius: "12px",
        mt: 2,
        m: "auto",
        height: "auto",

        overflow: "hidden",
        backgroundColor: theme.palette.background.main,
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        },
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          position: "relative",
          width: "100%",
          minHeight: { xs:200, sm: 200, md: 280 },
          height: {  sm: 200, md: 280 },
          overflow: "hidden",
          backgroundColor: "#f5f5f5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {data?.subscription?.truck_limit !== 1 && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              width: "65px",
            }}
          >
            <img
              src={premiumTruckLogo}
              style={{
                height: "auto",
                width: "100%",
                maxHeight: "65px",
                margin: "auto",
              }}
              alt="Premium"
            />
          </Box>
        )}

        {!imageLoaded && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            sx={{
              backgroundColor: "rgba(0,0,0,0.08)",
            }}
          />
        )}

        {imageSrc && (
          <img
            src={imageSrc}
            loading="lazy"
            alt={data?.title || "Catering Service Image"}
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              aspectRatio: "1.5",
              objectFit: "cover",
              objectPosition: "center",
              zIndex: 1,
              display: "block",
              margin: "auto",
            }}
          />
        )}
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          p: 2.5,
          backgroundColor: theme.palette.background.main,
        }}
      >
        <Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: theme.palette.text.dark,
                fontWeight: 700,
                textTransform: "capitalize",
                fontSize: { xs: "18px", md: "20px" },
              }}
            >
              {truncateCompanyName(
                index === 0 ? data?.truck_name : data?.company_name,
                25
              )}
            </Typography>
          </Box>

          <Chip
            label={
              data?.caterer_type === 1
                ? t("becomePartner.step2.types.type1")
                : data?.caterer_type === 3
                ? t("becomePartner.step2.types.type3")
                : data?.caterer_type === 4
                ? t("becomePartner.step2.types.type4")
                : t("becomePartner.step2.types.type2")
            }
            sx={{
              color: theme.palette.text.darkOrange,
              fontWeight: 600,
              mb: 1.5,
              borderRadius: "6px",
            }}
            size="small"
          />

          <Typography
            sx={{
              fontSize: "14px",
              color: theme.palette.text.secondary,
              mb: 0.5,
            }}
          >
            {t("explore.meal")}:
          </Typography>

          <Box
            className="removeDefault"
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.8,
              width: "100%",
              height: "60px",
              overflow: "hidden",
              pb: 1,
            }}
          >
            {data?.meal?.length > 0 ? (
              <>
                {data?.meal?.map((x, i) =>
                  i < 2 ? (
                    <Chip
                      key={i}
                      label={
                        i18n.language === "en-US" ? x?.meal_name : x?.german
                      }
                      size="small"
                      sx={{
                        backgroundColor: theme.palette.background.label,
                        color: theme.palette.text.label,
                        fontWeight: 500,
                        fontSize: "12px",
                        height: "24px",
                        borderRadius: "4px",
                      }}
                    />
                  ) : null
                )}
                {data?.meal?.length > 2 && (
                  <Chip
                    label={`+${data?.meal?.length - 2}`}
                    size="small"
                    sx={{
                      backgroundColor:
                        theme.palette.background.secondary || "#f5f5f5",
                      color: theme.palette.text.secondary,
                      fontWeight: 600,
                      fontSize: "12px",
                      height: "24px",
                      borderRadius: "4px",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor:
                          theme.palette.background.hover || "#e0e0e0",
                      },
                    }}
                  />
                )}
              </>
            ) : (
              <Typography
                variant="body2"
                sx={{
                  color: theme.palette.text.secondary,
                  fontStyle: "italic",
                }}
              >
                {t("explore.noMeals") || "No meal types available"}
              </Typography>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <ButtonComponent
            type="button"
            isAnimate={true}
            label={
              isOwner ? `${t("catSer.company.view")}` : t("explore.moreDetails")
            }
            onClick={() =>
              isOwner
                ? index === 0
                  ? openModal(data)
                  : companyId
                  ? navigate(NavRoutes.MY_COMPANY)
                  : redirect()
                : index === 0
                ? navigate(`${NavRoutes.TRUCK_DETAILS}/${data?.id}`, {
                    state: { id: data?.id, company_id: data?.company_id },
                  })
                : navigate(`${NavRoutes.COMPANY_DETAILS}/${data?.company_id}`)
            }
            sx={{
              width: "100%",
              background: theme.palette.background.btn,
              color: theme.palette.text.defaultLight,
              fontSize: "16px",
              borderRadius: "8px",
              padding: "8px 16px",
              // "&:hover": {
              //   background: theme.palette.background.btnHover || "#e65100",
              // },
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default CatServiceCard;
